<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body pt-2 px-2">
        <div class="row">
          <div class="col-xl-3" [ngClass.md]="'mr-1'">
            <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems()" />
          </div>
          <div class="col-xl-3 fix-ng-select-clear" [ngClass.sm]="'my-1'">
            <ng-select [(ngModel)]="filter_figure" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filter_figure > 0" (clear)="filter_figure = 0" (ngModelChange)="getItems()">
              <ng-option [value]="0">{{ "ALL_FIGURES" | translate }}</ng-option>
              <ng-option *ngFor="let figure of _userFigureService.list" [value]="figure.id">{{ figure.name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 fix-ng-select-clear">
            <ng-select [(ngModel)]="filter_client" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filter_client > 0" (clear)="filter_client = 0" (ngModelChange)="getItems()">
              <ng-option [value]="0">{{ "ALL_CLIENT" | translate }}</ng-option>
              <ng-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 fix-ng-select-clear" [ngClass.sm]="'my-1'">
            <ng-select [(ngModel)]="filter_opened" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" (clear)="filter_opened = -1" [clearable]="false" (ngModelChange)="getItems()">
              <ng-option value="-1">{{ "ALL_STATE" | translate }}</ng-option>
              <ng-option [value]="0">{{ "OPENED_FEMALE" | translate }}</ng-option>
              <ng-option [value]="1">{{ "CLOSED_FEMALE" | translate }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2" *ngIf="_utilService.isDesktop">
            <div class="w-fit ml-auto mr-0">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
          </div>
          <div class="col-12 my-05" *ngIf="_utilService.isDesktop"></div>
          <div class="col-xl-3 fix-ng-select-clear mb-05 mb-md-0">
            <label class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center mb-0" *ngIf="_utilService.isDesktop">&nbsp;</label>
            <ng-select has_capability="bargaining_view_others" [closeOnSelect]="true" [openOnEnter]="true" [(ngModel)]="filterCommercial" [clearable]="!!filterCommercial.hash" (clear)="filterCommercial = {hash: null, complete_name: null}" (change)="getItems()">
              <ng-template ng-label-tmp let-item="item">{{ 'CUSTOMER_COMMERCIAL' | translate }}: {{ item?.complete_name || ('ALL' | translate) }}</ng-template>
              <ng-option [value]="{ hash: null, complete_name: null }">{{ 'ALL' | translate }}</ng-option>
              <ng-option *ngFor="let comm of commercialList" [value]="comm">{{ comm.complete_name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 mb-05 mb-md-0">
            <div class="d-flex justify-content-between font-weight-normal align-items-center">
              <label for="filterFromDate" class="mb-0 font-small-3">{{ "FROM" | translate }}</label>
              <div class="text-primary cursor-pointer font-small-3" (click)="clearFilterFrom()">{{ 'REMOVE_FILTER' | translate }}</div>
            </div>
            <app-datepickr id="filterFromDate" [defaultDate]="filterFromDate" (onSelect)="filterFromDate = $event; getItems()" [displayMonths]="1"></app-datepickr>
          </div>
          <div class="col-xl-3 mb-05 mb-md-0">
            <div class="d-flex justify-content-between font-weight-normal align-items-center">
              <label for="filterFromDate" class="mb-0 font-small-3">{{ "TO" | translate }}</label>
              <div class="text-primary cursor-pointer font-small-3" (click)="clearFilterTo()">{{ 'REMOVE_FILTER' | translate }}</div>
            </div>
            <app-datepickr id="filterToDate" [defaultDate]="filterToDate" (onSelect)="filterToDate = $event; getItems()" [displayMonths]="1"></app-datepickr>
          </div>
          <div class="col-xl-3 text-md-right" [ngClass.md]="'mb-1'">
            <label class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center mb-0">&nbsp;</label>
            <button class="btn btn-outline-primary" routerLink="/dashboard/create-request" has_capability="create_customer_request">{{ "MENU.CREATE_REQUEST" | translate }}</button>
          </div>
        </div>
      </div>

      <!--desktop-->
      <div class="card-body p-0">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 70 : 190" [limit]="tableLimit" [footerHeight]="50" [rows]="filtered_list">
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="request_name" width="400" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'candidate' }">
                <span>{{ row.request_name }}</span>
              </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'CITY' | translate }}" prop="city" width="170" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.city }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'COMMERCIAL' | translate }}" prop="commerciale" width="170" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.commercial?.complete_name }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'INSERT_DATE' | translate }}" prop="date" width="120" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.date | date: "dd/MM/yyyy" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'PRIORITY' | translate }}" prop="priority" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-{{ row.priority === 0 ? 'danger' : 'success' }}">{{ (row.priority === 0 ? "NO" : "YES") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="closed" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-{{ row.closed === false ? 'success' : 'danger' }}">{{ (row.closed === false ? "OPENED_FEMALE" : "CLOSED_FEMALE") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="request_name" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12 p-0 text-break-line-1">
                  <a [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'candidate' }">
                    <span>{{ row.request_name }}</span>
                  </a>
                </div>
                <div class="col-12 p-0" *ngIf="row.commercial">{{'CUSTOMER_COMMERCIAL' | translate}}: {{ row.commercial?.complete_name }}</div>
                <div class="col-12 p-0">{{'CITY' | translate}}: {{ row.city }}</div>
                <div class="col-12 p-0">{{'INSERT_DATE' | translate}}: {{ row.date | date: "dd/MM/yyyy" }}</div>
                <div class="col-12 p-0 d-flex mb-1">
                  <div>
                    <span>{{ "PRIORITY" | translate }}: </span>
                    <span class="badge badge-{{ row.priority === 0 ? 'danger' : 'success' }}">{{ (row.priority === 0 ? "NO" : "YES") | translate }}</span>
                  </div>
                  <div class="ml-1">
                    <span>{{ "STATUS_LABEL" | translate }}: </span>
                    <span class="badge badge-{{ row.closed === false ? 'success' : 'danger' }}">{{ (row.closed === false ? "OPENED_FEMALE" : "CLOSED_FEMALE") | translate }}</span>
                  </div>
                </div>
                <div class="col-12" [ngClass.sm]="'p-0'" [ngClass.md]="'pr-2'">
                  <div class="d-flex justify-content-end">
                    <div ngbDropdown class="btn-group">
                      <button ngbDropdownToggle type="button" class="btn btn-sm btn-outline-primary" rippleEffect>{{ "VIEW_REQUEST" | translate }}</button>
                      <div ngbDropdownMenu>
                        <a ngbDropdownItem [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'candidate' }">{{ "TITLES.USERS_TYPES.candidate" | translate }}</a>
                        <a ngbDropdownItem [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'employee' }">{{ "TITLES.USERS_TYPES.employee" | translate }}</a>
                        <a ngbDropdownItem [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'ex_employees' }">{{ "TITLES.USERS_TYPES_SINGULAR.ex-employee" | translate }}</a>
                        <a ngbDropdownItem [routerLink]="'/dashboard/detail-request/' + row.id" [queryParams]="{ destination: 'proposed' }">{{ "TITLES.USERS_TYPES.suitables" | translate }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
